export const IMAGE_BASE_URL = process.env.VUE_APP_IMAGE_BASE_URL || '';

export function resolveBlockImageUrls(blocks) {
  if (!IMAGE_BASE_URL || !blocks) return;
  for (const block of blocks) {
    if (block.blockType === 'image' && block.content && block.content.startsWith('/images/')) {
      block.content = IMAGE_BASE_URL + block.content;
    }
  }
}
